import { IconSparkles } from '@tabler/icons-react'

// Marks a task as automatically generated (from a progress note or a lab result);
// callers detect this via queueFilters' isAiGenerated.
// Small, on-brand pill so an auto-generated task reads as such at a glance.
export const AiBadge = ({
  size = 'sm',
  className = '',
}: {
  size?: 'sm' | 'xs'
  className?: string
}) => (
  <span
    title="Automatically generated"
    className={`inline-flex shrink-0 items-center gap-1 rounded-full bg-[#EEF3FA] px-2 py-0.5 text-[11px] font-medium text-[#275587] ring-1 ring-[#D8E2F0] ring-inset ${className}`}
  >
    <IconSparkles size={size === 'xs' ? 11 : 12} />
    AI
  </span>
)
